module.exports = __webpack_public_path__ + "img/icon-add-active.c0ad9b1d.svg";